import { useStreakReminder } from '@/shared/hooks/useStreakReminder';
import { useToast } from '@/shared/hooks/useToast';

/**
 * Global streak reminder manager component.
 * Activates streak reminders for students and shows toast when streak is at risk.
 * Should be placed inside CelebrationProvider in App.tsx.
 */
export function StreakReminderManager() {
  const toast = useToast();

  useStreakReminder({
    reminderHour: 20, // 8pm
    showBrowserNotification: true,
    onStreakAtRisk: (currentStreak) => {
      // Also show an in-app toast for immediate visibility
      toast.warning(`¡Tu racha de ${currentStreak} días está en riesgo!`, {
        description: 'Completa una lección rápida para mantenerla.',
        duration: 10000,
      });
    },
  });

  // This component doesn't render anything visible
  return null;
}
